export function clearPhone(phone: string) {
  return phone.replace(/\D/g, '');
}
